import PropTypes from 'prop-types';
import React from 'react';
import GlobalNav from './GlobalNav';
import AuthStore from '@get-bridge/learn-legacy-shared/dist/stores/AuthStore';
import RuntimeStore from '@get-bridge/learn-legacy-shared/dist/stores/RuntimeStore';
import Runtime from '@get-bridge/learn-legacy-shared/dist/core/Runtime';
import BrandingOptions from '@get-bridge/learn-legacy-shared/dist/core/BrandingOptions';

export default class Navigation extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    path: PropTypes.string.isRequired,
    currentRouteName: PropTypes.string.isRequired,
    location: PropTypes.object,
    user: PropTypes.object,
  };

  componentDidMount() {
    RuntimeStore.addChangeListener(this.onRuntimeChange);
  }

  componentWillUnmount() {
    RuntimeStore.removeChangeListener(this.onRuntimeChange);
  }

  onRuntimeChange = () => this.forceUpdate();

  render() {
    const accountInfo = {
      whiteLabelEnabled: Runtime.get('ACCOUNT.config.whiteLabelEnabled'),
      supportLevel: Runtime.get('DOMAIN.config.supportLevel'),
      showCustomSupportInfo: Runtime.get('DOMAIN.config.showCustomSupportInfo'),
      supportName: Runtime.get('DOMAIN.config.supportName'),
      supportPhone: Runtime.get('DOMAIN.config.supportPhone'),
      supportEmail: Runtime.get('DOMAIN.config.supportEmail'),
      customerProvidedSupportHelpArticlesUrl: Runtime.get(
        'DOMAIN.config.customerProvidedSupportHelpArticlesUrl',
      ),
      customerProvidedSupportChatUrl: Runtime.get(
        'DOMAIN.config.customerProvidedSupportChatUrl',
      ),
      customSupportChatUrl: Runtime.get('DOMAIN.config.customSupportChatUrl'),
      customSupportPhoneNumber: Runtime.get(
        'DOMAIN.config.customSupportPhoneNumber',
      ),
      customSupportTicketUrl: Runtime.get(
        'DOMAIN.config.customSupportTicketUrl',
      ),
      customSupportHelpArticlesUrl: Runtime.get(
        'DOMAIN.config.customSupportHelpArticlesUrl',
      ),
    };
    const brandingInfo = {
      accentColor: BrandingOptions.getColor(),
      navigationColor: BrandingOptions.getNavColor(),
      colorEnabled: BrandingOptions.isColorEnabled(),
    };
    return (
      <div className="content-wrapper global-nav-wrapper">
        <GlobalNav
          location={this.props.location}
          currentUserInfo={this.props.user}
          profile={this.props.user}
          stopMasquerading={AuthStore.stopMasquerading.bind(AuthStore)}
          isMasquerading={AuthStore.isMasquerading()}
          userRoles={AuthStore.getRoles()}
          accountInfo={accountInfo}
          brandingInfo={brandingInfo}
        >
          {this.props.children && React.Children.only(this.props.children)}
        </GlobalNav>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/index.js